<template>
	<div class="payment">
		<!-- 订单提示 -->
		<div class="order-tip">
			<i class="el-icon-success tip-icon" />
			<span class="tip-text">您的订单已提交，请于12小时内完成支付</span>
		</div>

		<!-- 订单信息 -->
		<div class="order-info">
			<div class="info-row">
				<span class="info-label">
					价
					<span class="label-space" />
					<span class="label-space" />
					格：
				</span>
				<span class="info-value price">¥{{ price }}</span>
			</div>
			<div class="info-row">
				<span class="info-label">购买账号：</span>
				<span class="info-value">{{ maskAccount }}</span>
			</div>
			<div class="info-row highlight">
				<span class="info-label">实付金额：</span>
				<span class="info-value actual-price">¥{{ price }}</span>
			</div>
		</div>

		<!-- 分隔线 -->
		<div class="divider" />

		<!-- 支付方式 -->
		<div class="pay-way">
			<div class="pay-way-text">
				<span>请使用</span>
				<img class="pay-way-icon" src="~@/assets/pay-way.png" alt="支付方式" />
				<span>扫码支付</span>
			</div>
			<div class="qrcode-box">
				<img class="qrcode-img" src="~@/assets/qrcode.png" alt="支付二维码" />
			</div>
		</div>

		<!-- 购买须知 -->
		<div class="agreement">
			<el-checkbox v-model="agreed">
				<span class="agreement-text">
					购买须知《购买须知购买须知购买须知购买须知购买须知购买须知购买须知》
				</span>
			</el-checkbox>
		</div>
	</div>
</template>

<script>
	/**
	 * @description 购买流程-支付组件
	 */
	export default {
		name: 'Payment',
		props: {
			// 价格
			price: {
				type: String,
				default: '10W'
			},
			// 购买账号
			account: {
				type: String,
				default: '17612345678'
			}
		},
		data() {
			return {
				// 是否同意购买须知
				agreed: false
			}
		},
		computed: {
			// 脱敏账号
			maskAccount() {
				if (!this.account || this.account.length < 7) {
					return this.account
				}
				return this.account.slice(0, 3) + '*****' + this.account.slice(-2)
			}
		},
		methods: {
			// 获取表单数据
			getFormData() {
				return {
					price: this.price,
					account: this.account,
					agreed: this.agreed
				}
			},
			// 校验表单并返回数据
			validate() {
				return new Promise((resolve, reject) => {
					if (!this.agreed) {
						this.$message.warning('请先同意购买须知')
						reject(new Error('未同意购买须知'))
						return
					}
					resolve(this.getFormData())
				})
			},
			// 重置表单
			resetForm() {
				this.agreed = false
			}
		}
	}
</script>

<style lang="scss" scoped>
	.payment {
		padding: 20px 0;

		// 订单提示
		.order-tip {
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 24px;

			.tip-icon {
				font-size: 20px;
				color: #67c23a;
				margin-right: 8px;
			}

			.tip-text {
				font-size: 16px;
				color: #333;
			}
		}

		// 订单信息
		.order-info {
			width: 320px;
			margin: 0 auto 24px;

			.info-row {
				display: flex;
				align-items: center;
				margin-bottom: 12px;
				font-size: 14px;

				&:last-child {
					margin-bottom: 0;
				}

				.info-label {
					color: #666;
					min-width: 80px;
					margin-right: 8px;

					.label-space {
						display: inline-block;
						width: 1em;
					}
				}

				.info-value {
					color: #333;

					&.price {
						color: #e6a23c;
						font-weight: bold;
					}

					&.actual-price {
						color: #e6a23c;
						font-size: 24px;
						font-weight: bold;
					}
				}

				&.highlight {
					margin-top: 16px;
					padding-top: 12px;
				}
			}
		}

		// 分隔线
		.divider {
			width: 100%;
			height: 6px;
			background: #edf1f5;
			margin: 24px 0;
		}

		// 支付方式
		.pay-way {
			text-align: center;
			margin-bottom: 24px;

			.pay-way-text {
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 14px;
				color: #666;
				margin-bottom: 20px;

				.pay-way-icon {
					width: 60px;
					height: 30px;
					object-fit: contain;
					margin: 0 6px;
					vertical-align: middle;
				}
			}

			.qrcode-box {
				display: inline-block;
				padding: 12px;
				border: 1px solid #ebeef5;
				border-radius: 4px;
				background: #fff;

				.qrcode-img {
					width: 160px;
					height: 160px;
					display: block;
				}
			}
		}

		// 购买须知
		.agreement {
			text-align: center;
			margin-top: 20px;

			::v-deep .el-checkbox__label {
				font-size: 12px;
				color: #999;
			}

			.agreement-text {
				font-size: 12px;
				color: #999;
			}
		}
	}
</style>
